import type { FaireProductEntity } from "../../entity_types/product";

export const p_nkjxkbqaz9: FaireProductEntity = {
  token: "p_nkjxkbqaz9",
  type: "product",
  name: "18K Gold PVD Stainless Steel Nail Bangle",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/222e1f9c9a3d725ebb3bd02957084125cebc12564732adede19a0066208d071a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4212ab6032d9ee99f3a1d7cde0e48eca8df6f6400996336eb935f1451d0d290.jpeg",
    "https://cdn.faire.com/fastly/087d0e54768e043a60215c60fba3fc9d7d353f2e1c75a0425893c705f97f5afe.jpeg",
    "https://cdn.faire.com/fastly/71fbf3ef2e4a91b278b1ef0df0a2eb6e94205b5b167af6c05156eadde54a21db.jpeg",
    "https://cdn.faire.com/fastly/cf472086689bbcde75b5fb42de041ed15ffa76b4713d6894b870c245a84fe521.jpeg",
    "https://cdn.faire.com/fastly/9fc0b21e9f60acf59d9616e9887ceffd162969a7d44f802cd59154642acd68df.jpeg",
    "https://cdn.faire.com/fastly/c7542923575460d2a87cd872af19114f0200b256bbeacd14ad16879a8603f3ac.jpeg",
    "https://cdn.faire.com/fastly/9a88f5355d63406e1d6999dc49d04d734a1250abbc1ef45ee7ae26cee7041c73.jpeg",
    "https://cdn.faire.com/fastly/691b5c02def0e04e1971c3b954d0449154f38e46e24b6bb1ab14cec1c9b14cf7.jpeg",
    "https://cdn.faire.com/fastly/ba8b753596b09c67edd20ca5e5356fc5fe284fc6e79655723022d71d90413806.jpeg",
    "https://cdn.faire.com/fastly/9244bc2ca6a8f44058e5fba4c15fa4af3c95ab78109d5aadd6e8b4d32b4125f3.jpeg",
    "https://cdn.faire.com/fastly/c28cf1bd5f97fd8dadf8c7c065370b5ee3792b339e58b5e72dcebbf6d8fb89da.jpeg",
    "https://cdn.faire.com/fastly/6ed13a04efb2df836e0f62ca129cb499af06b8fbc19715f93db69a4f650c88a3.jpeg",
    "https://cdn.faire.com/fastly/1d39b0aa2ba13b072357e464e7114dbdefdcfa87a2d430272c3963f3b202ee7b.jpeg",
  ],
  priceDollars: 9.44,
  description:
    'Perfect for day-to-night styling, our 18K Gold PVD Stainless Steel Nail Bangle delivers a seamless blend of edgy chic and timeless luxury with a sleek silhouette designed for everyday wear.\n\n✦ 100% Waterproof, Non-tarnish, Hypoallergenic\n✦ Quality That Lasts\n✦ Designed for All Skin Types\n✦ Perfect for Every Budget\n\nWhy PVD?\nWe use Physical Vapor Deposition (PVD) to coat 18K Gold over 316L stainless steel. This process ensures a high-quality, non-tarnish finish that resists wear & will never turn skin green—ideal for jewelry to be worn every day.\n\nSize/Dimensions (Total Length): 7.45"\nSize/Dimensions (Thickness): 4mm\nSize/Dimensions (Nail Head): 9.80mm x 9.80mm\nWeight: 20.90g\n\nPerfect for nail bangles, modern gold bracelets, everyday statement jewelry, and boutique assortments.\n\nSame day shipping from Destin, FL before 3PM CST.',
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:55.231Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
